import store from '@/store';

export default async (to, from, next) => {
  if (store.getters['user/needUpdateApplication']) {
    next({ name: 'app-update' });
  } else {
    next();
  }
};
